import { IconColumnInsertRight } from '@tabler/icons-react';
import SimpleControl, {
  SimpleControlKind,
} from 'pages/revisions-module/template-editor/editors/template/toolbar/controls/SimpleControl';
import { useRichTextEditorContext } from '@mantine/tiptap';

/**
 * Adds a column after the selected column.
 */
export default function AddColumnAfter({ kind }: { kind: SimpleControlKind }) {
  const { editor } = useRichTextEditorContext();

  return (
    <SimpleControl
      kind={kind}
      label="Vložiť stĺpec vpravo"
      icon={<IconColumnInsertRight />}
      onClick={() => editor.chain().focus().addColumnAfter().run()}
    />
  );
}
